import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import styled from "styled-components";
import Profile from "./Profile";
import RelatedPostList from "./RelatePostList";
import TableOfContents2 from "./TableOfContents2";

type Props = {
  data: any
}

const SideBar = (props: Props) =>{
  const { tableOfContents,category } = props.data.mdx;
  const { posttype } = props.data.mdx.frontmatter;
  const Wrapper = styled.div`
    height: 100%;
    .sidebar{
      height: 100%;
      margin-top: 35px;
    }
    .nav{
      display: block;
    }
  `;
  return (
    <Wrapper>
      <div className="sidebar">
        <Profile />
        <RelatedPostList data={props.data}/>
        {tableOfContents && posttype !== 'issue' && (
          <TableOfContents2 toc={tableOfContents}/>
        )}
      </div>
    </Wrapper>
  );
}

export default SideBar;